import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Typography,
    Form,
    Input,
    Button,
    Spin,
    notification,
    Row,
    Col,
    theme,
} from "antd";
import pako from "pako";
import jwt_decode from "jwt-decode";
import UserApi from "../common/Apis/UserApi";
import RegisterForm from "../common/CommonUI/RegisterForm/RegisterForm";

const { Title } = Typography;
const CodeLogin = (props) => {
    const navigate = useNavigate();
    const { useToken } = theme;
    const { token } = useToken();
    const [loadings, setLoadings] = useState(false);
    const handleSubmit = async (data) => {
        setLoadings(true);

        try {
            // 1. Get public IP
            const ipResponse = await fetch("https://api.ipify.org?format=json");
            const ipData = await ipResponse.json();
            const publicIp = ipData.ip;

            // 2. Prepare form data
            const formData = new FormData();
            formData.append("userId", data.code);
            formData.append("ipAddress", publicIp); // <-- use dynamic IP here
            formData.append("laptopMac", "12345"); // (replace with real MAC if you capture it)

            // 3. Call API
            const response = await UserApi.loginWithCode(formData);

            setLoadings(false);

            // 4. Save JWT + decode
            localStorage.setItem("UserjwtToken", response?.payload?.jwtToken);

            const compressedData = Uint8Array.from(
                atob(response?.payload?.jwtToken),
                (c) => c.charCodeAt(0)
            );
            const decompressedData = pako.inflate(compressedData, { to: "string" });
            const decodedToken = jwt_decode(decompressedData);
            localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
            localStorage.setItem("loginCodeUsed", true);

            // 5. Notification + redirect
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>,
                description: "Welcome " + decodedToken.name,
                closeIcon: false,
                duration: 3,
                style: { backgroundColor: "#b3ffb3", color: "green" },
            });

            setTimeout(() => navigate("/dashboard"), 3000);
        } catch (err) {
            setLoadings(false);
            console.error(err);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: err?.apiError?.message || "Something went wrong",
                closeIcon: false,
                duration: 3,
                style: { backgroundColor: "#ffb3b3", color: "red" },
            });
        }
    };

    return (
        <>
            <div className="container container-body form-container">
                <div className="row justify-content-center">
                    <div className="col-xl-9 col-lg-9 col-md-9 content-border my-5">
                        <Row gutter={24}>
                            <RegisterForm />
                            <Col
                                lg={12}
                                md={24}
                                className="py-4"
                                style={{ boxShadow: "8px 8px 16px -4px rgba(0, 0, 0, 0.1)" }}
                            >
                                <Form
                                    name="nest-messages"
                                    layout="vertical"
                                    onFinish={handleSubmit}
                                    className="py-3 px-4 Register-form"
                                >
                                    <div className="d-flex justify-content-center pb-4">
                                        <img
                                            src="/assest/Images/Logo/logo.png"
                                            className="logo-png"
                                        />
                                    </div>

                                    <Title
                                        style={{
                                            textAlign: "center",
                                            color: "black",
                                            marginBottom: 30,
                                        }}
                                        level={4}
                                        className="Primary-Font"
                                    >
                                        Sign in to your account
                                    </Title>

                                    <>
                                        <p className="text-center" style={{ fontSize: "12px" }}>
                                            Please enter your login code for quick access
                                        </p>
                                        <Form.Item
                                            name="code"
                                            className="text-lable"
                                            rules={[
                                                {
                                                    required: true,
                                                    type: "text",
                                                    message: "login code is required",
                                                },
                                            ]}
                                        >
                                            <Input
                                                type="text"
                                                className="form-control control-input"
                                                placeholder="Enter your login code"
                                            />
                                        </Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className=" mt-2 w-100"
                                            disabled={loadings}
                                            style={{ background: token.colorPrimary, padding: '10px 0' }}
                                        >
                                            Continue with code{" "}
                                            {loadings == true && <Spin className="px-2" />}
                                        </Button>
                                        <p className="content signup-content py-4 my-5">
                                            Login with email and password ?{" "}
                                            <Link to={"/"} className="content-link">
                                                Sign In
                                            </Link>
                                        </p>
                                    </>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CodeLogin;
